import React, { useEffect, useState } from 'react'
import { TableContainer, TableCell, Table, TableRow, TableHead, TableBody, Paper, Stack, Typography, Button, Modal, Box } from '@mui/material'
import InputIcon from '@mui/icons-material/Input';
import { useCrudForm } from '../../api/useCrudForm';
import { endpoints } from '../../api/endpoints';
import { toast } from 'react-toastify';
import { TableHeadCell } from '../../components/styledComponent/table/TableCell';
import { SaveStyle } from "../../components/modal/modalBoxStyle";
import NotificationImportantIcon from '@mui/icons-material/NotificationImportant';
import { TablePagination } from '../../components/pagination/Pagination';

interface SelectedCustomerProps {
    customerId: string;
    lockerId: string;
    lockerNumber: string;
}

const OngoingTableLog = ({ ongoingVisits, refetch, loading, setLoading, fetchOngoingVisits, count }: { count: any, setLoading: any, fetchOngoingVisits: any, loading: any, ongoingVisits: Array<any>, refetch: (skip: any, take: any) => void }) => {
    const [endVisitModal, setEndVisitModal] = useState<boolean>(false);
    const [selectedCustomerVisit, setSelectedCustomerVisit] = useState<SelectedCustomerProps>({
        customerId: "",
        lockerId: "",
        lockerNumber: ""
    });

    const [skip, setSkip] = useState(0)
    const [take, setTake] = useState(10)

    useEffect(() => {
        setLoading('onGoing')
        fetchOngoingVisits(skip, take)
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [take, skip])

    return (
        <Paper sx={{ width: '100%', overflow: 'hidden' }}>
            <TableContainer sx={{ maxHeight: 460 }}>
                <Table stickyHeader aria-label="sticky table">
                    <TableHead>
                        <TableRow>
                            <TableHeadCell align="left">
                                Entry Time
                            </TableHeadCell>
                            <TableHeadCell align="left" minwidth="130px">
                                Customer
                            </TableHeadCell>
                            <TableHeadCell align="center" minwidth="40px">
                                Locker
                            </TableHeadCell>
                            <TableHeadCell align="center">
                                End Visit
                            </TableHeadCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {((ongoingVisits && ongoingVisits?.length <= 0) || loading === 'onGoing')
                            ?
                            <TableRow>
                                <TableCell colSpan={4} align='center'>No Data Found</TableCell>
                            </TableRow>
                            : ongoingVisits?.map((row, index) => (
                                <TableRow key={index} sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
                                    <TableCell style={{ fontSize: "12px", padding: "4px 6px" }}>{row.entryTime}</TableCell>
                                    <TableCell align='left' style={{ fontSize: "12px", padding: "4px 0" }}>{`${row.acNo} (${row.customerName})`}</TableCell>
                                    <TableCell align='center' style={{ fontSize: "12px", padding: "4px 6px" }}>{row.lockerNo}</TableCell>
                                    <TableCell align='center' style={{ padding: "4px 6px" }}>
                                        <InputIcon sx={{ color: 'red' }} onClick={() => {
                                            setSelectedCustomerVisit({
                                                customerId: row.customerId,
                                                lockerId: row.lockerId,
                                                lockerNumber: row.lockerNo
                                            })
                                            setEndVisitModal(true)
                                        }} />
                                    </TableCell>
                                </TableRow>
                            ))
                        }
                    </TableBody>
                </Table>
                <EndVisit open={endVisitModal} setOpen={setEndVisitModal} refetch={refetch} selectedCustomerVisit={selectedCustomerVisit} skip={skip} take={take} />
            </TableContainer>
            {ongoingVisits?.length > 0 ? <TablePagination count={count} skip={skip} setSkip={setSkip} take={take} setTake={setTake} /> : null}
        </Paper>


    )
}

export default OngoingTableLog

export function EndVisit({ open, setOpen, refetch, selectedCustomerVisit, skip, take }: { skip: any, take: any, open: boolean, setOpen: (value: boolean) => void, refetch: (skip: any, take: any) => void, selectedCustomerVisit: SelectedCustomerProps }) {

    const { add } = useCrudForm()

    const handleClose = () => setOpen(false);

    const manualEndVisit = () => {
        add({
            endpoints: endpoints.checkOut.manual,
            onSuccess: (t: any) => {
                refetch(skip, take);
                handleClose();
                toast.success(t.message, { style: { background: '#3150A1' } })
            },
            onError: (error: any) => {
                toast.error(error)
            },
            values: {
                customerId: selectedCustomerVisit.customerId,
                lockerId: selectedCustomerVisit.lockerId
            }
        })
    }

    return (
        <div>
            <Modal
                open={open}
                onClose={handleClose}
            >
                <Box sx={{ ...SaveStyle, width: 200, textAlign: 'center' }}>
                    <Stack spacing={2} alignItems='center' justifyContent={'center'}>
                        <NotificationImportantIcon sx={{ width: '60px', height: '60px', color: 'red' }} />
                        <Typography sx={{ margin: '0 0px 10px', padding: '0px' }}>Are you sure want to end visit for locker no {selectedCustomerVisit.lockerNumber} ?</Typography>
                        <Box sx={{ display: 'flex', gap: '10px' }}>
                            <Button onClick={() => manualEndVisit()} variant='contained' sx={{ backgroundColor: '#3150A1', color: 'white', width: '50%' }}>Confirm</Button>
                            <Button onClick={() => handleClose()} variant='contained' sx={{ backgroundColor: 'red', color: 'white', width: '50%' }} color='error' > Cancel</Button>
                        </Box>
                    </Stack>
                </Box >
            </Modal >
        </div>
    );
}


export function TablePaginationDemo() {
    const [page, setPage] = React.useState(2);
    const [rowsPerPage, setRowsPerPage] = React.useState(10);

    const handleChangePage = (
        event: React.MouseEvent<HTMLButtonElement> | null,
        newPage: number,
    ) => {
        setPage(newPage);
    };

    const handleChangeRowsPerPage = (
        event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>,
    ) => {
        setRowsPerPage(parseInt(event.target.value, 10));
        setPage(0);
    };

    return (
        <TablePagination
            component="div"
            count={100}
            page={page}
            onPageChange={handleChangePage}
            rowsPerPage={rowsPerPage}
            onRowsPerPageChange={handleChangeRowsPerPage}


        />
    );
}